export default "__VITE_ASSET__DxH5Mz7b__"